// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kxvT","icon":"styles_icon__2m0Gd"};